if (!customElements.get('ct-stock-status')) {
  customElements.define('ct-stock-status', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.host = this.closest('product-component') || this.closest('[data-section-type="product"]');
      this.update = (event) => {
        const variant = this.variants.find(v => String(v.id) === String(event.detail?.variant?.id));
        this.hidden = !variant?.available;
        if (!variant || this.dataset.mode === 'manual') return;
        const low = variant.tracked && variant.quantity > 0 && variant.quantity <= Number(this.dataset.low);
        this.classList.toggle('is-low', low);
        this.querySelector('[data-stock-text]').textContent = low ? this.dataset.limited : this.dataset.available;
      };
      this.host?.addEventListener('variantChange', this.update);
    }
    disconnectedCallback() { this.host?.removeEventListener('variantChange', this.update); }
  });
}
